/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events, no-unused-vars */

import React from 'react';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
    isArrayValidAndNotEmpty,
    isStringNullOrUndefined,
    isValidFunction,
    isValidNumber,
    isValidTextAndNotEmpty,
} from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { NumberOf } from '../../constants/numberUtils';
import NumberTextField from '../../components/NumberTextField';

const style = theme => ({
    error: {
        color: '',
    },
    largeFont: {
        fontSize: '18px !important',
    },
    warning: {
        color: '',
    },
    hover: {
        '&:hover': {
            backgroundColor: 'rgb(208, 231, 232)',
        },
        height: '35px',
    },
    button: {
        color: theme.palette.common.white,
        textTransform: 'initial',
        fontSize: '0.8rem',
        minHeight: '2em',
        height: '2em',
        minWidth: '5em',
        padding: '0 16px',
    },
});

class AddBulkItemsTableRow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.rowRef = React.createRef();
        this.state = {
            highlightRow: false,
        };
    }

    onToggleHighlight = (e) => {
        console.log('asd9-dua09dusjdaas', e);
        this.setState(prevState => ({
            highlightRow: !prevState.highlightRow,
        }));
    };

    onCheckBoxClick = (event, index, data) => {
        event.stopPropagation();
        if (this.props.onCheckBoxClick) {
            this.props.onCheckBoxClick(event, index, data);
        }
    };

    handleValueChange = (index, field, value) => {
        const {
            data,
            onCheckBoxClick,
            updateData,
        } = this.props;

        let updatedData = {
            ...data,
            [field.find]: value,
        };

        if (
            field.find === 'purchaseQuantity' &&
            isValidNumber(getStringFromObject('bonusPercentage', data, 0))
        ) {
            updatedData = {
                ...updatedData,
                bonus: (value * Number(getStringFromObject('bonusPercentage', data, 0))) / 100,
            };
        }

        if (isValidFunction(updateData)) {
            updateData(index, updatedData);
        }
    };

    showData = (field, data, isExpandable) => {
        const {
            classes,
            index,
            isSelected,
        } = this.props;
        let textToDisplay = '';
        if (isArrayValidAndNotEmpty(data)) {
            textToDisplay = data.map(d => getStringFromObject(field.find, d)).filter(Boolean).join(', ');
        } else {
            textToDisplay = getStringFromObject(field.find, data, field.default || '');
        }
        if (isStringNullOrUndefined(textToDisplay) && !isStringNullOrUndefined(field.alternateDefault)) {
            textToDisplay = getStringFromObject('alternateDefault', field || '');
        }

        switch (field.fieldType) {
        case 'text':
            return textToDisplay;
        case 'editableNumber':
            if (isSelected) {
                return (
                    <div className="flexWithCenterAligned">
                        <NumberTextField
                            input={{
                                value: NumberOf(textToDisplay),
                                onChange: (value) => {
                                    console.log('changed value', value);
                                    this.handleValueChange(index, field, value);
                                },
                                onBlur: () => {},
                                onFocus: () => {},
                            }}
                            meta={{
                                touched: false,
                                error: '',
                            }}
                            style={{ width: '50%' }}
                        />
                    </div>
                );
            }
            if (field.find === 'bonus') {
                return '--';
            }
            return textToDisplay;

        default:
            return <div>{textToDisplay}</div>;
        }
    };

    render() {
        const { highlightRow } = this.state;
        const {
            isSelected,
            index,
            tableCells,
            data,
            uniqueKey,
            classes,
            schema,
            tableName,
        } = this.props;
        return (
            <React.Fragment>
                <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isSelected}
                    tabIndex={index}
                    key={index}
                    className={classes.hover}
                    onClick={e => this.onRowClick(e, index, data[uniqueKey], data)}
                    selected={isSelected}
                    ref={this.rowRef}
                    test-id={`${tableName}[${index}]`}
                >
                    <TableCell padding="checkbox" style={{ width: '1em' }}>
                        <Checkbox
                            disableRipple
                            checked={isSelected}
                            color="primary"
                            onFocus={this.onToggleHighlight}
                            onBlur={this.onToggleHighlight}
                            onClick={e => this.onCheckBoxClick(e, index, data)}
                            data-test-id={`${tableName}-cb-[${index}]`}
                        />
                    </TableCell>
                    {
                        tableCells && tableCells.map((cell) => {
                            const { cellStyle } = cell;
                            return (
                                <TableCell
                                    component="td"
                                    key={cell.id}
                                    colSpan={cell.colSpan}
                                    test-id={`${tableName}[${index}].${cell.name}`}
                                    align={cell.align || 'left'}
                                    style={{ ...cellStyle }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: cell.align === 'right' ? 'flex-end' : 'unset',
                                        }}
                                    >
                                        <div style={cell.divStyle || {}}>
                                            {
                                                this.showData(cell, data, data.isExpandable)
                                            }
                                        </div>
                                    </div>
                                </TableCell>
                            );
                        })
                    }
                </TableRow>
            </React.Fragment>
        );
    }
}

AddBulkItemsTableRow.propTypes = {
    tableCells: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired,
    uniqueKey: PropTypes.string,
    isSelected: PropTypes.bool,
    schema: PropTypes.object,
    data: PropTypes.object,
    onCheckBoxClick: PropTypes.func,
    tableName: PropTypes.string.isRequired,
    updateData: PropTypes.func,
};

AddBulkItemsTableRow.defaultProps = {
    isSelected: false,
    uniqueKey: '',
    schema: {},
    data: {},
    onCheckBoxClick: () => { },
    updateData: () => { },
};

export default withStyles(style)(AddBulkItemsTableRow);
